import React from 'react';
import PropTypes from 'prop-types';

export default function LegendCross(props) {
  return (
    <svg width={40} height={12} viewBox="0 0 40 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 0H40V12H0V0Z" fill="white" />
      <path d="M0 1H40V11H0V1Z" fill={props.color || '#dddddd'} />
      <path d="M0 4H40V8H0V4Z" fill="#343434" />
      <rect x={8} width={6} height={12} fill="#343434" />
      <rect x={26} width={6} height={12} fill="#343434" />
    </svg>
  );
}

LegendCross.propTypes = {
  color: PropTypes.string
};
